import React, { useState } from 'react';
import {
  Tabs, TabsContent, TabsList, TabsTrigger,
} from '@frontend/shadcn/components/ui/tabs';
import { GetOfferById_offer } from '@frontend/applications/AffiliatesApp/queries/types/GetOfferById';
import { OFFER_SOURCE } from '@frontend/applications/AffiliatesApp/types/globalTypes';
import { GetAffiliateConversionHistory_affliateConversionHistory } from '@frontend/applications/AffiliatesApp/queries/types/GetAffiliateConversionHistory';
import RefreshCreatorDetails from './refresh-maincontent/refresh-details/RefreshCreatorDetails';
import { TSelectedAffliate } from '../MemberTable/types';
import { RefreshMemberConversionTable } from './RefreshMemberConversionTable';
import MemberBoostDetails from './MemberBoostDetails/MemberBoostDetails';
import { MemberBoosts } from './RefreshMemberConversionDrawer';

interface RefreshOfferTabsProps {
  offer: GetOfferById_offer;
  selectedMemberConversion: TSelectedAffliate;
  shortLinkForPromo: string;
  affiliateConversionHistory: GetAffiliateConversionHistory_affliateConversionHistory[];
  source: OFFER_SOURCE;
  refetchData: () => void
  refresh: () => void
  payoutLabel?: string
  isLoadingConversionHistory: boolean
  memberBoosts: MemberBoosts
  onClose: () => void
}

const RefreshOfferTabs: React.FC<RefreshOfferTabsProps> = ({
  offer,
  selectedMemberConversion,
  shortLinkForPromo,
  affiliateConversionHistory,
  source,
  refetchData,
  refresh,
  payoutLabel,
  isLoadingConversionHistory,
  memberBoosts,
  onClose,
}) => {
  const [activeTab, setActiveTab] = useState('overview');
  const boostOffer = memberBoosts && memberBoosts.length > 0;

  const tabs = [
    { id: 'overview', label: 'Overview' },
    ...(boostOffer ? [{ id: 'rewards', label: 'Rewards' }] : []),
    { id: 'conversion-history', label: 'Conversion History' },
  ];
  return (
    <Tabs
      value={activeTab}
      onValueChange={setActiveTab}
      className="w-full bg-white"
    >
      <TabsList className="h-auto bg-transparent border-b border-gray-200 p-0 gap-6 rounded-none w-full justify-start">
        {tabs.map((tab) => (
          <TabsTrigger
            key={tab.id}
            value={tab.id}
            className={`flex flex-col items-start px-0 py-0 rounded-none data-[state=active]:shadow-none data-[state=active]:bg-transparent hover:bg-transparent bg-transparent ${activeTab === tab.id
              ? 'font-medium text-grey-6'
              : 'font-normal text-grey-5'
              }`}
          >
            <span className="text-[14px] leading-[24px]">{tab.label}</span>
            <div
              className={`self-stretch w-full h-0.5 bg-grey-6 mt-[2px] ${activeTab === tab.id ? 'opacity-100' : 'opacity-0'
                }`}
            />
          </TabsTrigger>
        ))}
      </TabsList>

      <TabsContent value="overview">
        <RefreshCreatorDetails
          promoCode={selectedMemberConversion.code}
          affiliateLink={selectedMemberConversion.uniqueLink || shortLinkForPromo}
        />
      </TabsContent>
      <TabsContent value="rewards">
        <div className="flex flex-col gap-4">
          <MemberBoostDetails
            memberBoosts={memberBoosts}
            onClose={onClose}
            refetchData={refetchData}
            refresh={refresh}
          />
        </div>
      </TabsContent>
      <TabsContent value="conversion-history">
        <RefreshMemberConversionTable
          affiliateConversionHistory={affiliateConversionHistory}
          source={!offer.isPromoLink ? source : OFFER_SOURCE.PROMO_LINK}
          refetchData={refetchData}
          refresh={refresh}
          payoutLabel={payoutLabel}
          isLoadingConversionHistory={isLoadingConversionHistory}
        />
      </TabsContent>
    </Tabs>
  );
};

export default RefreshOfferTabs;
